import React, { Fragment } from "react";
import { Route, Routes, Navigate } from 'react-router-dom';
import { checkAuth } from "../../hooks/actions/sessionActions";
import AcessoRestrito from '../../pages/AcessoRestrito/AcessoRestrito';
import Logout from "../../pages/Logout/Logout";
import Login from '../../pages/Login/Login';

const PrivateRoute = ({ Item }) => {
    const session = checkAuth();
    return session ? <Item /> : <Login />;
};

const AppRoutes = () => {
    return (
        <Fragment>
            <Routes>
                <Route path="*" element={<Navigate to="/" />} />

                <Route path="/restrito" element={<PrivateRoute Item={AcessoRestrito} />} />
                
                <Route path="/logout" element={<Logout />} />
                
                <Route path="/" element={<Login />} />
            </Routes>
        </Fragment>
    );
};
export default AppRoutes;
